import api from "@/services/api"

export default async function confirmEmail(code) {
  const requestData = await api.patch(
    `/api/v1/authentication/confirm`,
    {},
    {
      params: {
        code: code,
      },
    }
  )

  return requestData.data
}
